let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("bL008"), load("1S9KM")]).then(() => parcelRequire('fKVtj'));